export default function({ app, store, req, redirect, route }) {
  // If nuxt generate, pass this middleware
  const isServer = process.server
  if (isServer && !req) return
  const assertQuiz = async (path, go) => {
    try {
      await store.dispatch('quiz/fetchState')
    } catch (e) {
      return
    }
    const { current } = store.state.quiz
    if (!current) {
      if (path.startsWith('/tv-vendas/video')) return
      return go('/tv-vendas')
    }
    if (path.startsWith(`/tv-vendas/quiz/${current._id}`)) return
    return go(`/tv-vendas/quiz/${current._id}/0`)
  }
  const assertCoaching = async (path, go) => {
    const { current } = store.state.coaching
    if (!current) {
      if (path.startsWith('/coaching/coachee')) return
      return go('/coaching')
    }
    if (current.coachingStage === 'feedback') return go('/coaching/feedback')
    const stage = store.getters['coaching/currentStage']
    if (stage) {
      if (!stage.form) return go('/coaching/forms')
      if (path.startsWith('/coaching/form/questions')) return
      if (path.startsWith('/coaching/form/pdv')) return
      if (path.startsWith('/coaching/pdvs/observation')) return
      const { questions } = stage.form
      if (stage.stage === 'process' && questions?.length)
        return go('/coaching/form/pdv')
      const firstUnanswered = questions.findIndex(
        ({ answer }) => answer === null
      )
      const jumpTo =
        firstUnanswered >= 0 ? firstUnanswered : questions.length - 1
      return go(`/coaching/form/questions/${jumpTo}`)
    }
    if (path.startsWith('/coaching/pdv')) return
    return go('/coaching/pdvs')
  }
  const ensureRoute = async _path => {
    const path = _path || route.path
    const go = newPath =>
      newPath === path || path === `${newPath}/` || redirect(newPath)
    if (path.startsWith('/coaching')) return await assertCoaching(path, go)
    if (path.startsWith('/tv-vendas')) return await assertQuiz(path, go)
  }
  app.$ensureRoute = ensureRoute
  return ensureRoute()
}
